import { createSlice } from "@reduxjs/toolkit";

import {
  assignGroupToUserAction,
  assignUsersToGroupAction,
  createUserAction,
  createUserGroupAction,
  getAllMenuListAction,
  getAllUserGroupsAction,
  getAssignedGroupToUserAction,
  getAssignedUsersToGroupAction,
  getSingleUserGroupDetailsAction,
  updateMenuListAction,
  updateUserGroupAction,
} from "@/redux/userManagement/actions";
import { initialState } from "@/redux/userManagement/initialState";
import { userManagementReducer } from "@/redux/userManagement/reducer";
import type { UserManagementType } from "@/redux/userManagement/userManagementTypes";

export const userManagementSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: userManagementReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getAllMenuListAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllMenuListAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        let sideMenu: any = [];
        let modules: any = [];
        let others: any = [];

        result?.length > 0 &&
          result?.map((menu: any) => {
            menu?.category === "side_menu"
              ? sideMenu.push(menu)
              : menu?.category === "others"
                ? others.push(menu)
                : modules.push(menu);
          });

        return {
          ...state,
          fetching: false,
          menuList: result,
          statusCode: status_code,
          sideMenuList: sideMenu,
          moduleList: modules,
          othersList: others,
        };
      }
    );

    builder.addCase(
      getAllMenuListAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      createUserGroupAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createUserGroupAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      createUserGroupAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      assignGroupToUserAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      assignGroupToUserAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          success: 1,
          fetching: false,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      assignGroupToUserAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(createUserAction.pending, (state: UserManagementType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      createUserAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, status_code, message, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          success: 1,
          fetching: false,
          statusCode: status_code,
          createMenuMessage: result,
        };
      }
    );

    builder.addCase(
      createUserAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateMenuListAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateMenuListAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateMenuListAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      updateUserGroupAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateUserGroupAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          createUserId: result,
        };
      }
    );

    builder.addCase(
      updateUserGroupAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getAllUserGroupsAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAllUserGroupsAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message, count } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          userGroupList: result,
          userGroupCount: count,
        };
      }
    );

    builder.addCase(
      getAllUserGroupsAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAssignedGroupToUserAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAssignedGroupToUserAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          assignedGroupListCount: result?.total_count,
          assignedGroupList: result?.data,
        };
      }
    );

    builder.addCase(
      getAssignedGroupToUserAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAssignedUsersToGroupAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getAssignedUsersToGroupAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          assignedUsersToGroupList: result,
        };
      }
    );

    builder.addCase(
      getAssignedUsersToGroupAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      assignUsersToGroupAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      assignUsersToGroupAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      assignUsersToGroupAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );

    builder.addCase(
      getSingleUserGroupDetailsAction.pending,
      (state: UserManagementType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleUserGroupDetailsAction.fulfilled,
      (state: UserManagementType, { payload }) => {
        const { success, result, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            error: message,
            statusCode: status_code,
            fetching: false,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          group_menu: result?.group_menu,
          group_name: result?.group_name,
          editUserGroupData: {
            group_menu: result?.group_menu,
            group_name: result?.group_name,
          },
        };
      }
    );

    builder.addCase(
      getSingleUserGroupDetailsAction.rejected,
      (state: UserManagementType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
        success: 0,
      })
    );
  },
});

export const {
  resetSideMenuList,
  resetModulesList,
  resetUserManagementError,
  resetUserManagementFetching,
  resetUserManagementStatusCode,
  resetUserManagementSuccess,
  resetEditUserGroupData,
  resetUserGroupList,
  resetGroupMenu,
  resetGroupName,
  resetUserGroupCount,
  resetAssignedGroupListCount,
  resetOthersList,
} = userManagementSlice.actions;
